import React, { forwardRef } from 'react';
import { styled } from '@mui/material';
import { useHistory } from 'react-router-dom';

import Box from 'shell/components/Box';
import Button from 'shell/components/Button';
import Stack from 'shell/components/Stack';
import Text from 'shell/components/Text';

const CustomStack = styled(Stack)(() => {
    return {
        height: '4rem',
    };
});

const ActiveIndicator = styled(Box)(({ theme }) => {
    return {
        borderRadius: '0.125rem',
        width: '4.5rem',
        height: '0.25rem',
        background: theme.palette.ensightful.primary[500],
    };
});

const CustomBox = styled(Box)(({ active }) => {
    return {
        position: 'relative',
        ...(active && {
            marginTop: '-0.25rem',
        }),
    };
});

const CustomButton = styled(Button)(({ active, theme }) => {
    return {
        borderColor: 'transparent !important',
        color: theme.palette.ensightful.neutral[700],
        transition: 'none',
        '& svg': {
            marginTop: '-0.125rem !important',
            marginRight: '0.125rem !important',
            fontSize: '1.5rem !important',
        },
        '&:hover': {
            color: theme.palette.ensightful.primary[500],
        },
        ...(active && {
            color: theme.palette.ensightful.primary[500],
        }),
    };
});

const NotificationDot = styled(Box)(({ theme }) => {
    return {
        position: 'absolute',
        top: '0.4rem',
        left: '1.4rem',
        borderRadius: '50%',
        width: '0.625rem',
        height: '0.625rem',
        background: theme.palette.ensightful.primary[500],
    };
});

export default forwardRef(({ children, active, hasNotification, startIcon, to, ...rest }, ref) => {
    const history = useHistory();

    return (
        <CustomStack alignItems={'center'} justifyContent={'space-between'} {...rest}>
            {active ? <ActiveIndicator /> : <Box />}
            <CustomBox active={active}>
                <CustomButton
                    ref={ref}
                    active={active}
                    color={'neutral'}
                    startIcon={startIcon}
                    variant={'tertiary'}
                    onClick={() => history.push(to)}
                >
                    <Text color={'inherit'} variant={'p1'} weight={'semibold'}>
                        {children}
                    </Text>
                </CustomButton>
                {hasNotification && <NotificationDot />}
            </CustomBox>
            <Box />
        </CustomStack>
    );
});
